<template>
  <tr class="direct-debt-row">
    <td>
      <router-link :to="'/membership/members/' + directDebit.Account.uuid">
        {{ directDebit.Account.dropdownLabel }}
      </router-link>
    </td>
    <td>
      <div class="text-center">
        {{ directDebit.cost | to_dollar_amount }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ directDebit.startDate | short_date_format }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ directDebit.endDate | short_date_format }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ directDebit.lastPaid | short_date_format }}
      </div>
    </td>
    <td>
      <div class="text-center">
        {{ nextPayment | short_date_format }}
      </div>
    </td>
    <td>
      <div class="text-center">
        <span class="fa" :class="completed ? 'fa-check text-success' : 'fa-times text-danger'"></span>
      </div>
    </td>
    <td>
      <router-link class="btn btn-sm btn-primary" :to="'/membership/direct-debit/edit/' + directDebit.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'DirectDebitRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    directDebit () {
      return {
        Account: {},
        ...this.object
      }
    },
    nextPayment () {
      if (this.directDebit.lastPaid) {
        return moment(this.directDebit.lastPaid).add(1, 'month')
      } else {
        return moment(this.directDebit.startDate)
      }
    },
    completed () {
      return moment(this.directDebit.endDate).subtract(1, 'month').isBefore(moment())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/DirectDebit.vue